import React from 'react';
import {
    arrayOf,
    func,
    string,
    number,
    bool,
    shape,
    oneOfType,
    object
} from 'prop-types';

import KeywordFilter from '../filters/keyword-filter';

import ResultCount from './result-count/';
import SortBy from './sort-by/';
import { getActiveValues } from '../utils/active-filters';

export default function ToolbarSection({
    showResultCount,
    itemCount,
    sortBy,
    currentSort,
    updateSort,
    countLabel,
    keywordFilter,
    activeFilters,
    toggleFilters,
    keywordPlaceholderText,
    isProductFinder
}) {
    if (!showResultCount && (!sortBy || !sortBy.length)) {
        return null;
    }

    const activeValues = getActiveValues(keywordFilter, activeFilters);

    return (
        <div className="listing-toolbar-section">
            <div className="listing-toolbar-container">
                <div className="listing-toolbar">
                    {isProductFinder && (
                        <KeywordFilter
                            key={keywordFilter.code}
                            filter={keywordFilter}
                            keyword={activeValues.length ? activeValues[0] : ''}
                            updateKeyword={toggleFilters}
                            placeholderText={
                                keywordPlaceholderText
                                    ? keywordPlaceholderText
                                    : 'Enter keywords'
                            }
                            classModifier="filter-item"
                        />
                    )}
                    {showResultCount && (
                        <ResultCount
                            count={itemCount}
                            countLabel={countLabel}
                        />
                    )}
                    <SortBy
                        items={sortBy}
                        currentSort={currentSort}
                        updateSort={updateSort}
                    />
                </div>
            </div>
        </div>
    );
}

ToolbarSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    showResultCount: bool.isRequired,
    itemCount: number.isRequired,
    sortBy: arrayOf(
        shape({
            label: string.isRequired,
            field: string.isRequired,
            ascending: bool.isRequired
        })
    ),
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired,
    countLabel: string.isRequired,
    keywordFilter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number]))
    }),
    activeFilters: arrayOf(
        shape({
            code: string.isRequired,
            label: string.isRequired,
            values: arrayOf(oneOfType([string, bool, number])).isRequired
        })
    ).isRequired,
    toggleFilters: func.isRequired,
    keywordPlaceholderText: string,
    isProductFinder: bool
    /* eslint-enable react/no-typos */
};

ToolbarSection.defaultProps = {
    sortBy: [],
    currentSort: ''
};
